import { Button } from '@chakra-ui/react';

export default function ExpandToggleButton({
  label,
  onClick,
}: {
  label: string;
  onClick: () => void;
}) {
  return (
    <Button
      variant="link"
      alignSelf="flex-start"
      color="neutral.1300"
      // 13px: no exact theme token (Chakra xs=12, sm=14); holding raw px pending design.
      fontSize="13px"
      fontWeight="medium"
      textDecoration="underline"
      minW="auto"
      height="auto"
      verticalAlign="baseline"
      _hover={{ color: 'neutral.1300' }}
      onClick={onClick}
    >
      {label}
    </Button>
  );
}
